import { Container, Text } from './styles'
import logo_white from '../../../assets/logo/logo_white.png'


export const Slider = () => {


  return (
    <Container.main>
      <Container.text>
        <Container.box>
          {/* <img src={logo_white} alt="logo" style={{
            width: '120px',
            marginRight: '30px',
            marginBottom: '30px'
          }}  /> */}
          <Container.wrapper>
            {/* <Text.subTitle>Faça sua carreira acontecer enquanto torna o mundo mais sustentável.</Text.subTitle> */}
            {/* <Text.desc>
              Por muito tempo vimos artistas independentes sem recursos para investir na própria carreira. A parceria A Fábrica Criativa + Gooders nasce para democratizar o acesso à execução profissional e, ao mesmo tempo, gerar impacto social real.
              <Container.button><button> <a href="/#doGoodDay">Saiba Mais</a></button></Container.button>
            </Text.desc> */}
          </Container.wrapper>
        </Container.box>
      </Container.text>
    </Container.main >
  )
}
